import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
    LocalizationProvider,
    renderTimeViewClock,
    TimePicker,
    TimePickerProps
} from '@mui/x-date-pickers';
import { de } from 'date-fns/locale';

export const DHTimePicker = (props: TimePickerProps) => {
    return (
        // For now, we only support the de format for time values (14:30)
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
            <TimePicker
                sx={{ flex: 1, '.MuiInputBase-root': { height: 56 } }}
                viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock
                }}
                {...props}
            />
        </LocalizationProvider>
    );
};
